import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import { deviceInfoProvider } from 'src/utils'
import { Link } from 'gatsby'

// ArComponents
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const StyledWrapper = styled.article`
  background-color: ${ p => p.theme.colors.gallery };
  margin: 55px auto 25px;
  max-width: ${ p => p.theme.gridWidthBlog + 'px' };
  padding-bottom: 35px;
  padding-top: 30px;

  ${ media.tablet`
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    margin-bottom: 50px;
  ` }

  ${ media.desktop`
    margin-top: 68px;
    margin-bottom: 72px;
  ` }
`

const StyledImage = styled(ArBaseImage)`
  margin: 0 -6px 45px;

  ${ media.tablet`
    margin: -7px 0 0 -18px;
    flex-shrink: 0;
    width: 39.25%;
    max-width: 270px;
    align-self: flex-start;
  ` }

  ${ media.desktop`
    margin-bottom: -9px;
  ` }
`

const StyledTextWrapper = styled.div`
  padding-left: ${ p => p.theme.gridGutterMobile + 'px' };
  padding-right: ${ p => p.theme.gridGutterMobile + 'px' };

  ${ media.tablet`
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 50px;
  ` }

  ${ media.desktop`
    padding-top: 45px;
    padding-bottom: 34px;
  ` }
`

const StyledLogo = styled(ArBaseImage)`
  margin: 0 auto 20px;
  width: 97px;

  ${ media.tablet`
    margin-left: 0;
  ` }
`

const StyledDescription = styled.p`
  color: ${ p => p.theme.colors.mineShaft2 };
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.611;
  margin-bottom: 15px;
  text-align: center;

  ${ media.tablet`
    text-align: left;
    max-width: 330px;
  ` }

  ${ media.desktop`
    margin-right: 0;
    max-width: none;
  ` }
`

const StyledCTA = styled(Link)`
  color: ${ p => p.theme.colors.toryBlue };
  display: block;
  font-family: ${ ({ theme }) => theme.font.secondary };
  font-size: 1.3rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.secondary.Regular };
  line-height: 1.23;
  text-align: center;

  ${ media.tablet`
    text-align: left;
  ` }
`

class ArCompanyAdvertisement extends React.Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    })),
    logo: PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    }),
    description: PropTypes.string,
    cta: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    }),
  }

  get deviceImage () {
    if (this.props.device.isDesktop) return this.props.images[2]
    else if (this.props.device.isTablet) return this.props.images[1]
    else if (this.props.device.isMobile) return this.props.images[0]
    else return {}
  }

  render () {
    const { logo, description, cta } = this.props

    return (
      <StyledWrapper>
        <StyledImage src={this.deviceImage.url} alt={this.deviceImage.alt} />
        <StyledTextWrapper>
          <h3>
            <StyledLogo src={logo.url} alt={logo.alt} />
          </h3>
          <StyledDescription>{ description }</StyledDescription>
          <StyledCTA to={cta.url}>{ cta.title }</StyledCTA>
        </StyledTextWrapper>
      </StyledWrapper>
    )
  }
}

export default deviceInfoProvider(ArCompanyAdvertisement)
